import React, { useEffect, useState } from 'react';
// import './LandingPage.css';
import CuisineCard from '../components/CuisineCard';

import { fetchWithCSRF } from '../utils/csrfUtils';
import { Spinner } from 'react-bootstrap';

const CuisineCardsSelector = ({ sessionToken, onCuisineClick }) => {
    const [cuisines, setCuisines] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!sessionToken) return;

        const fetchCuisines = async () => {
            try {
                const response = await fetchWithCSRF('/api/v1/cuisine', {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${sessionToken}`
                    }
                });

                if (!response.ok) {
                    throw new Error(`Failed to fetch cuisines: ${response.status}`);
                }

                const data = await response.json();
                
                // Validate the response data
                if (!Array.isArray(data)) {
                    throw new Error('Invalid data format: expected an array of cuisines');
                }

                setCuisines(data);
                setError(null);
            } catch (error) {
                console.error('Error fetching cuisines:', error);
                setError('Failed to load cuisine options');
            } finally {
                setIsLoading(false);
            }
        };

        fetchCuisines();
    }, [sessionToken]);

    if (isLoading) {
        return (
            <div className="text-center my-4">
                <Spinner animation="border" role="status" style={{ color: '#52cd92' }}>
                    <span className="visually-hidden">Loading cuisines...</span>
                </Spinner>
            </div>
        );
    }

    if (error) {
        return (
            <div className="alert alert-warning" role="alert">
                <p className="mb-0">{error}</p>
            </div>
        );
    }

    if (!cuisines.length) {
        return (
            <div className="alert alert-info" role="alert">
                <p className="mb-0">No cuisine options available at the moment.</p>
            </div>
        );
    }

    return (
        <div className="cuisine-cards">
            <div className="diet-card-container">
                {cuisines.map(cuisine => (
                    <CuisineCard key={cuisine.id} cuisine={cuisine} onClick={onCuisineClick} />
                ))}
            </div>
        </div>
    );
};

export default CuisineCardsSelector;